import { useCallback, useEffect, useState } from 'react';
import { getLogs } from '../../services/LogsService';

/**
 * props:
 * - file
 */
function LogView(props) {

    const [logs, setLogs] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const loadLogs = useCallback(() => {
        if (!props.file) return;
        setLoading(true);
        setError('');
        getLogs(props.file)
            .then(data => setLogs(typeof data === 'string' ? data : JSON.stringify(data, null, 2)))
            .catch(err => {
                const msg = err.response ? err.response.data : err.message;
                setError(typeof msg === 'string' ? msg : 'Erro ao carregar logs.');
                setLogs('');
            })
            .finally(() => setLoading(false));
    }, [props.file]);

    useEffect(() => {
        loadLogs();
    }, [loadLogs]);

    return (
        <div className="row">
            <div className="col-12 mb-2 d-flex justify-content-between align-items-center">
                <label htmlFor="logs" className="mb-0">Logs: {props.file || ''}</label>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    onClick={loadLogs}
                    disabled={loading || !props.file}
                >
                    {loading ? 'Atualizando…' : 'Atualizar'}
                </button>
            </div>
            <div className="col-12 mb-3">
                {error && <div className="alert alert-danger py-2">{error}</div>}
                <textarea
                    id="logs"
                    value={logs || (loading ? 'Carregando…' : 'Sem logs ainda. Entradas, saídas e erros do grid aparecem aqui.')}
                    readOnly
                    className="form-control"
                    style={{
                        fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
                        fontSize: '0.82rem',
                        minHeight: '60vh',
                        whiteSpace: 'pre',
                        overflow: 'auto'
                    }}
                />
            </div>
        </div>
    );
}

export default LogView;
